'use client'

import { OrderCard } from '@/components/molecules/orders'

interface OrdersListProps extends React.ComponentPropsWithoutRef<'div'> {
  data: any[]
}

export const OrdersList = ({ data }: OrdersListProps) => {
  return (
    <div className="flex w-full flex-col gap-1.5 p-1">
      {data?.map((order) => {
        const { id, cart } = order || {}
        const orderId = cart?.id ?? id

        return <OrderCard order={order} key={orderId} />
      })}
    </div>
  )
}
